/**
 * OpportunityCalculatorPage — AIP-internal route at /#/calculator.
 *
 * v2.3: 22 gate-check questions across 10 sections.
 * Full 22-question gate-check + Quick Score 7-question mode both unlocked.
 * No NDA wall — every AIP user is already inside the platform.
 *
 * Palette: Navy #0B0B0F · Red #DC2626 · AIP bg #FAFAF7
 * No emojis. M-PACT with hyphen.
 */
import { useEffect } from "react";
import OperatorShell from "@/components/operator/OperatorShell";
import SecondaryNav, { type SecondaryNavRole } from "@/components/dashboards/SecondaryNav";
import OpportunityCalculator from "@/components/calculator/OpportunityCalculatorV2";
import { getSession } from "@/lib/session";

function roleForNav(): SecondaryNavRole {
  const r = getSession()?.role;
  if (r === "manager") return "management";
  if (r === "executive" || r === "marketing" || r === "ae" || r === "bdr" || r === "se") {
    return r;
  }
  return "all";
}

export default function OpportunityCalculatorPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Opportunity Checkpoint Calculator — Attilius";
    return () => { document.title = prev; };
  }, []);

  return (
    <OperatorShell breadcrumbs={[{ label: "Opportunity Calculator" }]} pageTitle="Opportunity Calculator" pageMeta="Deal calculator">
      <SecondaryNav role={roleForNav()} />

      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <header className="mb-8">
          <p
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.32em",
              color: "#DC2626",
              textTransform: "uppercase",
              marginBottom: 12,
            }}
          >
            Checkpoint calculator · Manufacturing pilot
          </p>
          <h1
            style={{
              fontSize: 36,
              fontWeight: 800,
              color: "#0B0B0F",
              letterSpacing: "-0.02em",
              lineHeight: 1.1,
              marginBottom: 12,
            }}
          >
            Opportunity Calculator
          </h1>
          <p
            style={{
              fontSize: 15,
              color: "#525258",
              lineHeight: 1.6,
              maxWidth: 760,
            }}
          >
            22 checkpoint questions across 10 sections. Use the Full checkpoint audit to
            audit a deal end-to-end, or Quick Score for a directional read in under
            two minutes before a call. Five-point graded scale — skip any checkpoint you
            cannot answer yet. Composite 0-100, per-section breakdown, and a plain
            go / no-go verdict. Manufacturing pilot: industrial, automotive, aerospace,
            building materials, industrial equipment, contract manufacturing.
          </p>
        </header>

        <OpportunityCalculator inAip />
      </main>
    </OperatorShell>
  );
}
